import {blue} from "@material-ui/core/colors";
import React from "react";
import {T} from "@tolgee/react";
import {makeLowerCase} from "tools/show/localMap";
import {IResolvedLocalMap, LocalMapType} from "@evennt-tech/api-v2-core";

const getAlertInfo = (email: string, localMap: IResolvedLocalMap) => {
  const showLabel = makeLowerCase(localMap.show, LocalMapType.Show);
  return (
    <>
      <T keyName="exhibitor.cart.bank_transfer.alert.title" />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.intro"
        params={{b: <b />}}
      />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.multiple_suppliers"
        params={{b: <b />}}
      />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.po_numbers"
        params={{b: <b />}}
      />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.invoices"
        params={{
          b: <b />,
          email: (
            <span
              style={{
                color: blue.A400,
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {email}
            </span>
          ),
        }}
      />
      <br />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.payment_terms"
        params={{b: <b />}}
      />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.terms_lt_2_months"
        params={{b: <b />, showLabel}}
      />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.terms_gt_2_months"
        params={{b: <b />, showLabel}}
      />
      <br />
      <br />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.read_before"
        params={{b: <b />}}
      />
      <br /> <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.onboarding"
        params={{b: <b />}}
      />
      <br />
      <T keyName="exhibitor.cart.bank_transfer.alert.marketplace" />
      <br />
      <T
        keyName="exhibitor.cart.bank_transfer.alert.recommend_card"
        params={{b: <b />}}
      />
    </>
  );
};

export default getAlertInfo;
